const supportAccountIdsStr: string = import.meta.env.VITE_SUPPORT_ACCOUNTS
export const supportAccountIds = supportAccountIdsStr
  ? supportAccountIdsStr.split(',')
  : []
